// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1XSgy"};
module.exports.__checksum = "d4048eb5339e"